import type { PersistedPage } from "schemas";
import { apiRequest } from "../apiRequest";
import { setPage } from "./setPage";

export async function getPage(id?: string) {
  const page = await apiRequest<PersistedPage>({ url: `pages${id ? `/${id}` : ""}` });

  setPage(page);
}
